import { matchPath } from 'quartz-routing/react-router';
import { AC_ASSISTANT_URL_FRAGMENT, AC_ASSISTANT_WIZARD_URL_FRAGMENT, AC_ONBOARDING_URL_FRAGMENT, AWARD_OVERLAY_URL_FRAGMENT, AWARD_SHARE_REDIRECT_URL_FRAGMENT, AWARD_URL_FRAGMENT, EDIT_PROFILE_URL_FRAGMENT, HOME_URL_FRAGMENT, HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT, LEGACY_AWARD_OVERLAY_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, LEGACY_MY_TEAM_URL_FRAGMENT, LEGACY_MYLEARNING_URL_FRAGMENT, LEGACY_OVERVIEW_URL_FRAGMENT, LEGACY_SHARE_AWARD_URL_FRAGMENT, LEGACY_WATCH_LATER_PAGE_URL_FRAGMENT, LEGACY_WATCH_LATER_URL_FRAGMENT, LESSON_BY_ID_URL_FRAGMENT, LESSON_PAGE_URL_FRAGMENT, LESSONS_URL_FRAGMENT, MY_PLAYLISTS_PAGE_URL_FRAGMENT, MY_PLAYLISTS_TAB_PAGE_URL_FRAGMENT, MY_PLAYLISTS_TAB_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, MY_TEAM_CERTIFICATION_PROFILE_REDIRECT_URL_FRAGMENT, MY_TEAM_CERTIFICATION_PROFILE_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_BY_TEAM_REDIRECT_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_BY_TEAM_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT, MY_TEAM_PLAYLISTS_REDIRECT_URL_FRAGMENT, MY_TEAM_PLAYLISTS_URL_FRAGMENT, MY_TEAM_URL_FRAGMENT, MYLEARNING_URL_FRAGMENT, PARTNER_TRACKS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, PRACTICE_MODE_URL_FRAGMENT, PROFILE_URL_FRAGMENT, QA_ONLY_URL_FRAGMENT, RESULTS_URL_FRAGMENT, SAVED_ITEMS_URL_FRAGMENT, SHARE_ACHIEVEMENT_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT, SHORT_URL_FRAGMENT, SOFTWARE_DISCOVERY_URL_FRAGMENT, TRACK_BY_ID_URL_FRAGMENT, TRACK_PAGE_URL_FRAGMENT, TRACKS_URL_FRAGMENT, USER_PROFILE_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, WIZARD_CATEGORY_URL_FRAGMENT, WIZARD_HUBSPOT_SOFTWARE_OPTIONAL_URL_FRAGMENT, WIZARD_HUBSPOT_SOFTWARE_URL_FRAGMENT, WIZARD_OPTIONAL_URL_FRAGMENT } from './academyRoutePaths';
export const APP_NAMES = ['LearningCenterUI', 'academy-home-ui', 'academy-learning-ui', 'academy-playlist-ui', 'academy-team-ui', 'academy-achievement-ui', 'academy-public-achievement-ui', 'academy-content-ui'];
export const AC_ROUTE_CONFIG = {
  // --- exact routes first ---
  AC_ONBOARDING: {
    appName: 'LearningCenterUI',
    path: AC_ONBOARDING_URL_FRAGMENT,
    exact: true
  },
  SHARE_ACHIEVEMENT: {
    appName: 'LearningCenterUI',
    path: SHARE_ACHIEVEMENT_URL_FRAGMENT,
    exact: true
  },
  HOME: {
    appName: 'LearningCenterUI',
    path: HOME_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_CERTIFICATION_PROFILE: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_CERTIFICATION_PROFILE_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_CERTIFICATION_PROFILE_REDIRECT: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_CERTIFICATION_PROFILE_REDIRECT_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_CERTIFICATIONS: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_CERTIFICATIONS_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_CERTIFICATIONS_BY_TEAM: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_CERTIFICATIONS_BY_TEAM_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_CERTIFICATIONS_BY_TEAM_REDIRECT: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_CERTIFICATIONS_BY_TEAM_REDIRECT_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_PLAYLISTS: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_PLAYLISTS_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_PLAYLISTS_REDIRECT: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_PLAYLISTS_REDIRECT_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM_MEMBERS: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_MEMBERS_URL_FRAGMENT,
    exact: true
  },
  MY_TEAM: {
    appName: 'LearningCenterUI',
    path: MY_TEAM_URL_FRAGMENT,
    exact: true
  },
  LEGACY_MY_TEAM: {
    appName: 'LearningCenterUI',
    path: LEGACY_MY_TEAM_URL_FRAGMENT,
    exact: true
  },
  EDIT_PROFILE: {
    appName: 'LearningCenterUI',
    path: EDIT_PROFILE_URL_FRAGMENT,
    exact: true
  },
  USER_PROFILE: {
    appName: 'LearningCenterUI',
    path: USER_PROFILE_URL_FRAGMENT,
    exact: true
  },
  PROFILE: {
    appName: 'LearningCenterUI',
    path: PROFILE_URL_FRAGMENT,
    exact: true
  },
  HUBSPOT_PLAYLISTS_ADMIN: {
    appName: 'LearningCenterUI',
    path: HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT,
    exact: true
  },
  MY_PLAYLISTS: {
    appName: 'LearningCenterUI',
    path: [MY_PLAYLISTS_TAB_PAGE_URL_FRAGMENT, MY_PLAYLISTS_PAGE_URL_FRAGMENT, MY_PLAYLISTS_TAB_URL_FRAGMENT],
    exact: true
  },
  PLAYLIST: {
    appName: 'LearningCenterUI',
    path: [PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT],
    exact: true
  },
  LEGACY_AWARD: {
    appName: 'LearningCenterUI',
    path: LEGACY_AWARD_URL_FRAGMENT,
    exact: true
  },
  AWARD: {
    appName: 'LearningCenterUI',
    path: AWARD_URL_FRAGMENT,
    exact: true
  },
  // --- non-exact routes (more specific before parent) ---
  SOFTWARE_DISCOVERY: {
    appName: 'academy-content-ui',
    path: SOFTWARE_DISCOVERY_URL_FRAGMENT
  },
  PRACTICE_MODE: {
    appName: 'academy-content-ui',
    path: PRACTICE_MODE_URL_FRAGMENT
  },
  AC_ASSISTANT: {
    appName: 'LearningCenterUI',
    path: AC_ASSISTANT_URL_FRAGMENT
  },
  AC_ASSISTANT_WIZARD: {
    appName: 'academy-home-ui',
    path: AC_ASSISTANT_WIZARD_URL_FRAGMENT
  },
  WIZARD: {
    appName: 'academy-home-ui',
    path: [WIZARD_HUBSPOT_SOFTWARE_URL_FRAGMENT, WIZARD_HUBSPOT_SOFTWARE_OPTIONAL_URL_FRAGMENT, WIZARD_CATEGORY_URL_FRAGMENT, WIZARD_OPTIONAL_URL_FRAGMENT]
  },
  RESULTS: {
    appName: 'academy-home-ui',
    path: RESULTS_URL_FRAGMENT
  },
  PARTNERS: {
    appName: 'academy-home-ui',
    path: PARTNER_TRACKS_URL_FRAGMENT
  },
  MY_LEARNING: {
    appName: 'LearningCenterUI',
    path: MYLEARNING_URL_FRAGMENT
  },
  LEGACY_MY_LEARNING: {
    appName: 'LearningCenterUI',
    path: LEGACY_MYLEARNING_URL_FRAGMENT
  },
  WATCH_LATER: {
    appName: 'LearningCenterUI',
    path: WATCH_LATER_URL_FRAGMENT
  },
  QA_ONLY: {
    appName: 'LearningCenterUI',
    path: QA_ONLY_URL_FRAGMENT
  },
  SHORT_VIDEO: {
    appName: 'academy-content-ui',
    path: SHORT_URL_FRAGMENT
  },
  // /tracks: most specific to parent
  TRACK_PAGE: {
    appName: 'LearningCenterUI',
    path: [TRACK_PAGE_URL_FRAGMENT]
  },
  TRACK_BY_ID: {
    appName: 'LearningCenterUI',
    path: TRACK_BY_ID_URL_FRAGMENT
  },
  TRACKS: {
    appName: 'LearningCenterUI',
    path: TRACKS_URL_FRAGMENT
  },
  // /lessons: most specific to parent
  LESSON_PAGE: {
    appName: 'LearningCenterUI',
    path: LESSON_PAGE_URL_FRAGMENT
  },
  LESSON_BY_ID: {
    appName: 'LearningCenterUI',
    path: LESSON_BY_ID_URL_FRAGMENT
  },
  LESSONS: {
    appName: 'LearningCenterUI',
    path: LESSONS_URL_FRAGMENT
  },
  // /award-share: most specific to parent
  SHARE_AWARD_PREVIEW: {
    appName: 'LearningCenterUI',
    path: SHARE_AWARD_PREVIEW_URL_FRAGMENT
  },
  LEGACY_SHARE_AWARD: {
    appName: 'LearningCenterUI',
    path: LEGACY_SHARE_AWARD_URL_FRAGMENT
  },
  AWARD_SHARE_REDIRECT: {
    appName: 'LearningCenterUI',
    path: AWARD_SHARE_REDIRECT_URL_FRAGMENT
  },
  // /saved-items: most specific to parent
  LEGACY_WATCH_LATER: {
    appName: 'LearningCenterUI',
    path: [LEGACY_WATCH_LATER_PAGE_URL_FRAGMENT, LEGACY_WATCH_LATER_URL_FRAGMENT]
  },
  SAVED_ITEMS_PLAYLISTS: {
    appName: 'LearningCenterUI',
    path: MY_PLAYLISTS_URL_FRAGMENT
  },
  SAVED_ITEMS: {
    appName: 'LearningCenterUI',
    path: SAVED_ITEMS_URL_FRAGMENT
  },
  // overlay: most specific to parent
  LEGACY_AWARD_OVERLAY: {
    appName: 'LearningCenterUI',
    path: LEGACY_AWARD_OVERLAY_URL_FRAGMENT
  },
  AWARD_OVERLAY: {
    appName: 'LearningCenterUI',
    path: AWARD_OVERLAY_URL_FRAGMENT
  },
  // broad wildcard, last
  LEGACY_OVERVIEW: {
    appName: 'LearningCenterUI',
    path: LEGACY_OVERVIEW_URL_FRAGMENT
  }
};
export function selectACRoutes(appName) {
  const result = {};
  for (const [key, entry] of Object.entries(AC_ROUTE_CONFIG)) {
    if (!appName || entry.appName === appName) {
      result[key] = entry.path;
    }
  }
  return result;
}
export const findACRouteForPath = pathname => {
  for (const value of Object.values(AC_ROUTE_CONFIG)) {
    const {
      path,
      exact
    } = value;
    if (matchPath(pathname, {
      path,
      exact
    })) {
      return value;
    }
  }
  return null;
};